module.exports = __webpack_public_path__ + "assets/img/3e2c-cm.svg";